//Configurable Content

//Determines the theme of the application
export const THEME: 'dark' | 'light' = 'light'

/** Use this prop to display the brand image to orient beside the editable content */
export const BRAND_IMAGE_ORIENTATION: 'left' | 'right' | 'none' = 'left'

// Determines whether to show/hide forgot username link in the login flow
export const SHOW_FORGOT_USERNAME_LINK = true

// Determines whether to show/hide forgot password link in the login flow
export const SHOW_FORGOT_PASSWORD_LINK = true

// Determines whether to show/hide header across the application
export const SHOW_HEADER = false

// Determines whether to show/hide footer across the application
export const SHOW_FOOTER = true

// Determines whether to show/hide the Sign and Enroll Tab
export const SHOW_SIGNIN_AND_ENROLL_TAB = true

// Determines buttons alignment on all screens by the form inputs
export const ALIGN_BUTTONS_AND_LINKS: 'left' | 'right' | 'center' = 'left'

//Determines how forgot username and forgot password links should be shown if visible
export const FORGOT_LINKS_LAYOUT: 'stack' | 'inline' = 'stack'
